import React, {useEffect, useRef, useState} from "react";
import {mrbgStore, redFldToWhite} from './mrbgRedux';
import {mrbgTools} from "../../mrbgLib/mrbgTools.js";

function MrbgTextarea({formID,name,other,fldAttr,formsSettings,formStyle}){

  const
    refInp = useRef(),
    [inpVal ,setInpVal ] = useState(''),
    [micCls,setMicCls] = useState(formStyle.mrbgMicro+' fa-solid fa-microphone-slash'),
    [redFld,setRedFld] = useState( mrbgStore.getState().formsSettings[formID]?.redFld );

  function changeInpVal(val){
    setInpVal(val);
    if( val!=='' )
      mrbgStore.dispatch(redFldToWhite({formID,fieldName:name}));
  }
  function listening(){
    if( mrbgTools.recog.listening ){
      mrbgTools.recog.stop()
      setMicCls(formStyle.mrbgMicro+' fa-solid  fa-microphone-slash');
    }
    else if( micCls==formStyle.mrbgMicro+' fa-solid fa-microphone '+formStyle.activeMrbgMicro ){
      setMicCls(formStyle.mrbgMicro+' fa-solid  fa-microphone-slash');
    }
    else{
      mrbgTools.recog.start();
      mrbgTools.recog.mrbgTI=refInp.current;
      setMicCls(formStyle.mrbgMicro+' fa-solid fa-microphone '+formStyle.activeMrbgMicro);
    }
  }

  useEffect(()=>{},[inpVal]);
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setRedFld(mrbgStore.getState().formsSettings[formID]?.redFld)
    })
    return () =>unsubscribe();
  },[]);

  return(
    <>
      <textarea name={name} className={redFld?.includes(name)? formStyle.emptyField: ''} disabled={formsSettings?.disabled.includes(name)? true:false} {...other} onChange={e=>changeInpVal(e.target.value)} ref={refInp}/>
      {fldAttr.className.includes('mrbgVoice')? <i className={micCls} onClick={()=>listening()}></i>: ''}
    </>
  )
}
export default MrbgTextarea;